import { css } from "@emotion/react";
import React from "react";
import PropTypes from "prop-types";
import { useFormContext } from "@/core/providers/FormProvider";
import { em } from "@util/convertUnits";

function FieldError({
    name,
    css: passedCss
}) {

    const { formErrors } = useFormContext();
    const myErrors = formErrors[name];

    if (!myErrors) return null;

    const style = css(`
        margin-bottom: ${em(8, 14)};
        font-size: ${em(14)};
        color: #da6d6d;
    `);

    return (
        <div data-field-error-name={name} className="field-error" css={[passedCss, style]}>
            {
                myErrors.map((err) => {
                    return <div key={err} className="line">{err}</div>
                })
            }
        </div>
    );
}

FieldError.propTypes = {
    name: PropTypes.string,
    css: PropTypes.array,
};

export default FieldError;
